export const urlAccess = [
    //#region - ALL USERS
    // ROUTES ALLOWED FOR ALL USERS
    {
        route: "/Dashboard",
        accessAllowed: ["all"]
    },
    {
        route: "/Attendance",
        accessAllowed: ["all"]
    },
    {
        route: "/Attendance/AttendanceList",
        accessAllowed: ["all"]
    },
    {
        route: "/Attendance/MarkAttendance",
        accessAllowed: ['all']
    },
    {
        route: "/Attendance/LeaveHistory",
        accessAllowed: ['all']
    },
    {
        route: "/Attendance/RequestLeave",
        accessAllowed: ['all']
    },
    {
        route: "/HumanResource",
        accessAllowed: ['all']
    },
    {
        route: "/KnowledgeShare",
        accessAllowed: ['all']
    },
    {
        route: "/HolidayList",
        accessAllowed: ['all']
    },
    {
        route: "/Attendance/RequestLeave",
        accessAllowed: ['all']
    },
    {
        route: "/Attendance/RequestLeave",
        accessAllowed: ['all']
    },

    //#endregion

    //#region ISR
    // ROUTES ALLOWED FOR ISR ONLY
    {
        route: "/CustList",
        accessAllowed: ["isr", "director"]
    },
    {
        route: "/EditCustomer",
        accessAllowed: ["isr", "director"]
    },
    {
        route: "/modifyCust",
        accessAllowed: ["isr", "director"]
    },
    {
        route: "/ViewCustomer",
        accessAllowed: ["isr", "director"]
    },
    {
        route: "/CustContact",
        accessAllowed: ["isr"]
    },
    {
        route: "/CreateQuotation",
        accessAllowed: ["isr", "manager", "user", "sales"]
    },
    {
        route: "/QuotationList",
        accessAllowed: ["isr", "manager", "user", "sales"]
    },
    {
        route: "/FormQuotation",
        accessAllowed: ["isr", "manager", "user", "sales"]
    },
    {
        route: "/Pdfhtml",
        accessAllowed: ["isr", "manager", "user", "sales"]
    },
    {
        route: "/OrderDefault",
        accessAllowed: ["isr",  "manager", "user", "sales", "administrator"]
    },
    {
        route: "/OrderGenerateList",
        accessAllowed: ["isr", "manager", "user", "sales", "administrator"]
    },
    {
        route: "/OrderGenerate",
        accessAllowed: ["isr", "manager", "user", "sales", "administrator"]
    },
    {
        route: "/OrderProcessedList",
        accessAllowed: ["isr", "manager", "user", "sales", "administrator"]
    },
    {
        route: "/OrderProcessed",
        accessAllowed: ["isr", "manager", "user", "sales", "administrator"]
    },
    {
        route: "/EngineerConfirmationList",
        accessAllowed: ["isr", "manager", "user", "sales", "administrator"]
    },
    {
        route: "/EngineerConfirmation",
        accessAllowed: ["isr", "manager", "user", "sales", "administrator"]
    },
    //#endregion 

    //#region - HR 
    // ROUTES ALLOWED FOR HR USERS
    {
        route: "/HrEmployeeList",
        accessAllowed: ["hr", "administrator", "director"]
    },
    {
        route: "/EditEmployee",
        accessAllowed: ["hr", "administrator", "director"]
    },
    {
        route: "/ViewEmployee",
        accessAllowed: ["hr", "administrator", "director"]
    },
    {
        route: "/EmpProduct",
        accessAllowed: ["hr", "administrator", "director"]
    },
    {
        route: "/HR",
        accessAllowed: ["hr", "administrator", "director"]
    },
    {
        route: "/HrEmpDesig",
        accessAllowed: ["hr", "administrator"]
    },
    {
        route: "/HREmpDept",
        accessAllowed: ["hr", "administrator"]
    },
    {
        route: "/ManageHoliday",
        accessAllowed: ["hr", "administrator"]
    },
    {
        route: "/HrEmpTargetList",
        accessAllowed: ["hr", "administrator"]
    },
    {
        route: "/HrEmpTarget",
        accessAllowed: ["hr", "administrator"]
    },
    {
        route: "/LeaveDetail/EmployeeLeaveDetail",
        accessAllowed: ["hr", "administrator"]
    },
    {
        route: "/LeaveDetail/AddNewEmployeeLeave",
        accessAllowed: ["hr", "administrator"]
    },
    //#endregion

    //#region OPU
    // ROUTES ALLOWED FOR OPU
    {
        route: "/OrderProcessDefault",
        accessAllowed: ["opu", "director"]
    },
    {
        route: "/OrderList/OPUApproval",
        accessAllowed: ["opu", "director"]
    },
    {
        route: "/OPUApprovalEdit",
        accessAllowed: ["opu", "director"]
    },
    //#endregion 

    //#region DAR
    {
        route: "/DarSummary",
        accessAllowed: ["manager", "user", "sales"]
    },
    {
        route: "/EditDar",
        accessAllowed: ["manager", "user", "sales"]
    },
    {
        route: "/ViewDar",
        accessAllowed: ["manager", "user", "sales", "director"]
    },
    {
        route: "/ContinueDar",
        accessAllowed: ["manager", "user", "sales"]
    },
    {
        route: "/AddDar",
        accessAllowed: ["manager", "user", "sales"]
    },
    {
        route: "/WeeklyActivity",
        accessAllowed: ["manager", "user", "sales"]
    },
    {
        route: "/DailyActivityReport",
        accessAllowed: ["manager", "user", "sales", "director"]
    },
    {
        route: "/PriceList",
        accessAllowed: ["manager", "user", "sales"]
    },
    //#endregion

    //#region PROJECT
    // PROJECT - this view is an exception as these routes does not depend upon the type of user but the user's vertical.
    {
        route: "/Projects/ManageProject",
        accessAllowed: ["all"]
    },
    {
        route: "/Projects/ProjectAllocation",
        accessAllowed: ["all"]
    },
    {
        route: "/Projects/ApprovedActivity",
        accessAllowed: ["all"]
    },
    {
        route: "/Projects/AssignedProject",
        accessAllowed: ["all"]
    },
    {
        route: "/Projects/ActivityStatus",
        accessAllowed: ["all"]
    },

    //#endregion

    //#region - DIRECTOR
    // ROUTES ALLOWED FOR DIRECTOR
    {
        route: "/DailyActivityReport",
        accessAllowed: ["director"]
    },

    //#endregion
]